<div class="widget-group p-8" fxLayout="column wrap" fxFlex="100" *fuseIfOnDom >

  <div *ngIf="esCheckbox" fxFlex="100">
    <mat-checkbox  class="example-margin" [(ngModel)]="sentencia.cumpleNoCumple" 
    [disabled]="debidaDiligenciaEstado!='INICIADO' || action == 'View'"
    (ngModelChange)="saveCheckboxValue($event)"></mat-checkbox>
  </div>

  <div *ngIf="esTextoLibre" fxFlex="100" >
      <textarea placeholder="Respuesta" matInput [(ngModel)]="sentencia.valor" 
      (blur)="saveValue($event.target.value)" class="text-response"
      [disabled]="debidaDiligenciaEstado!='INICIADO' || action == 'View'">
    </textarea>
  </div>

  <div fxLayout="row wrap">
    <div *ngIf="esAdjuntos" fxFlex="100" >
        <input type="file" multiple (change)="uploadFiles($event)" 
        [disabled]="debidaDiligenciaEstado!='INICIADO' || action == 'View'">
    </div>
    <div *ngIf="esAdjuntos" fxFlex="100" fxLayout="row wrap" class="p-12">
        <div *ngFor="let archivo of sentencia.adjuntos" fxLayout="row wrap" class="p-5 clickeable" (click)="descargarArchivo(archivo)">
          <div class="p-5" >
              <mat-icon  aria-hidden="false" aria-label="download" >cloud_download</mat-icon>
          </div>
          <div style="padding-left: 15px; padding-top: 5px;">{{ archivo.substring(archivo.lastIndexOf('/')+1) }}</div>
            
        </div>
      </div>
  </div>

</div>

